import { create } from 'zustand';

import { createStoreSelectors } from 'utilities/createStoreSelectors';

interface ThemeState {
  theme: 'light' | 'dark';
  setTheme: (theme: ThemeState['theme']) => void;
}

const useStore = create<ThemeState>()((set) => ({
  theme: 'light',
  setTheme: (v) => set({ theme: v }),
}));

export const themeStore = createStoreSelectors(useStore);
